import { Label } from '@launchpad-ui/components';
import clsx from 'clsx';

import { RequiredLabel } from '../../../CreateMetricModal/components/RequiredLabel';

import styles from './MetricConfigRow.module.css';

/**
 * A metric configuration row with the label in a fixed left gutter and the control
 * to its right, so a stack of rows shares one alignment.
 */
export const MetricConfigRow: React.FC<{
  label: string;
  /** Associates the label with the control. */
  htmlFor?: string;
  /** Set so a composite control that cannot be labelled by `htmlFor` can name itself after this label. */
  labelId?: string;
  /** Rendered beside the label, for a field that already carries a HelpTooltip today. */
  tooltip?: React.ReactNode;
  /** Rendered directly beneath the control, sharing its left edge. */
  error?: React.ReactNode;
  /** Set when the row sits in a grid of rows that share one label column. */
  inGrid?: boolean;
  /** Set when the control below refuses to submit empty, so the row's label carries the marker. */
  isRequired?: boolean;
  className?: string;
  children: React.ReactNode;
}> = ({ label, htmlFor, labelId, tooltip, error, inGrid = false, isRequired = false, className, children }) => (
  <div className={clsx(styles.configRow, inGrid && styles.configRowInGrid, className)}>
    <span className={styles.configRowLabel}>
      {isRequired ? (
        <RequiredLabel label={label} htmlFor={htmlFor} id={labelId} />
      ) : (
        <Label id={labelId} htmlFor={htmlFor}>
          {label}
        </Label>
      )}
      {tooltip}
    </span>
    <div className={styles.configRowControl}>
      {children}
      {error}
    </div>
  </div>
);
